export enum TypeDeclarationEnum {
  SUBSTITUTE = 'Sustitutiva',
  COMPLEMENTARY = 'Complementaria',
  RECTIFYING = 'Rectificativa',
  }